import { Component } from '@angular/core';
import { UserDetailsCustomersComponent } from 'gung-standard';

@Component({
  selector: 'car-liner-user-details-customers',
  standalone: false,
  templateUrl: './car-liner-user-details-customers.component.html',
  styleUrl: './car-liner-user-details-customers.component.scss'
})
export class CarLinerUserDetailsCustomersComponent extends UserDetailsCustomersComponent {}
